import React, { useState, useEffect } from "react";
import {
  
  Typography,
  IconButton,
  
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {BACKEND_BASE_URL} from "../../config"
import api from "../../components/api";
import { marked } from "marked";  // Markdown Parser

// Toast configuration
toast.configure();

export default function Chat() {
  const [conversations, setConversations] = useState([]);
  const [activeChat, setActiveChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [typingDots, setTypingDots] = useState(".");

  const getAuthToken = () => localStorage.getItem("authToken");

  useEffect(() => {
    fetchConversations();
  }, []);

  useEffect(() => {
    if (isTyping) {
      const interval = setInterval(() => {
        setTypingDots((prev) => (prev.length < 3 ? prev + "." : "."));
      }, 500);
      return () => clearInterval(interval);
    }
  }, [isTyping]);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Enter" && currentMessage.trim()) {
        handleSendMessage();
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [currentMessage]);

  const fetchConversations = async () => {
    try {
      const response = await api.get(`${BACKEND_BASE_URL}/api/conversations/list/`);

      const data = response.data;
      setConversations(data);
    } catch (error) {
      console.error(error.message);
      toast.error("Failed to load conversations.");
    }
  };

  const handleNewChat = () => {
    setActiveChat(null);
    setMessages([]);
    setCurrentMessage("");
  };

  const loadMessages = async (conversationId) => {
    try {
      const response = await api.get(
        `${BACKEND_BASE_URL}/api/conversations/${conversationId}/messages/`);

      const data = response.data
      setMessages(data.messages || []);
      setActiveChat(conversationId);
    } catch (error) {
      console.error(error.message);
      toast.error("Failed to load messages.");
    }
  };

  const handleDeleteConversation = async (conversationId) => {
    try {
      const response = await api.delete(
        `${BACKEND_BASE_URL}/api/conversations/${conversationId}/delete/`,);


      setConversations((prev) =>
        prev.filter((conversation) => conversation.id !== conversationId)
      );

      if (activeChat === conversationId) {
        setActiveChat(null);
        setMessages([]);
      }

      toast.success("Conversation deleted successfully!");
    } catch (error) {
      console.error("Error deleting conversation:", error.message);
      toast.error("Failed to delete the conversation.");
    }
  };

  const handleSendMessage = async () => {
    const token = localStorage.getItem("authToken");
    if (!currentMessage.trim()) return;

    const userMessage = {
      id: Date.now(),
      text: currentMessage,
      is_bot: false,
      created_at: new Date().toISOString(),
    };

    setMessages((prev) => [...prev, userMessage]);
    setCurrentMessage("");
    setIsTyping(true);

    try {
      let response;

      if (activeChat) {
        response = await api.post(
          `${BACKEND_BASE_URL}/api/conversations/${activeChat}/messages/`,
          {
             message: currentMessage ,
          },
          {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
        );
      } else {
        
        response = await api.post(`${BACKEND_BASE_URL}/api/conversations/`, 
          { message: currentMessage },
          {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
        );
        const newConversation =  response.data;
        console.log("response : ",newConversation)
        setConversations((prev) => [newConversation, ...prev]);
        setActiveChat(newConversation.id);

        if (newConversation.messages) setMessages(newConversation.messages);

        setIsTyping(false); // Stop typing indicator for a new conversation
        return;
      }

      const responseData = response.data;
      setIsTyping(false); // Stop typing indicator once the backend responds

      if (responseData.bot_message) {
        setMessages((prev) => [...prev, responseData.bot_message]);
      }
    } catch (error) {
      setIsTyping(false); // Stop typing indicator even if there's an error
      console.error("Error sending message:", error.message);
      toast.error("Failed to send the message.");
    }
  };
 
  return (
    <div
      style={{
        display: "flex",
        height: "87vh",
        backgroundColor: "#eef2f5",
        overflow: "hidden",
      }}
    >
      {/* Sidebar */}
      <div
        style={{
          flexShrink: 0,
          width: "250px",
          minWidth: "200px",
          maxWidth: "300px",
          backgroundColor: "#ffffff",
          borderRight: "1px solid #ddd",
          boxShadow: "2px 0px 5px rgba(0, 0, 0, 0.1)",
          padding: "16px",
          overflowY: "auto",
        }}
      >
        <Typography
          variant="h5"
          style={{ color: "#3f51b5", fontWeight: "bold", marginBottom: "16px" }}
        >
          Conversations
        </Typography>
        <button
          onClick={handleNewChat}
          style={{
            display: "block",
            width: "100%",
            marginBottom: "16px",
            padding: "10px",
            color: "#fff",
            backgroundColor: "#0B194A",
            border: "none",
            borderRadius: "20px",
            cursor: "pointer",
          }}
        >
          New Chat
        </button>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {conversations.map((conversation) => (
            <React.Fragment key={conversation.id}>
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px",
                  borderRadius: "10px",
                  cursor: "pointer",
                  backgroundColor:
                    activeChat === conversation.id ? "#e3f2fd" : "transparent",
                }}
                onClick={() => loadMessages(conversation.id)}
              >
                <span style={{ color: "#333", whiteSpace: "nowrap", 
          overflow: "hidden",  
          textOverflow: "ellipsis", 
          maxWidth: "80%", }}>
                  {conversation.title || "Untitled"}
                </span>
                <IconButton
                  aria-label="delete"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteConversation(conversation.id);
                  }}
                  style={{ color: "#f50057" }}
                >
                  <DeleteIcon />
                </IconButton>
              </li>
              <hr style={{ margin: "8px 0", borderColor: "#ddd" }} />
            </React.Fragment>
          ))}
        </ul>
      </div>
  
      {/* Chat Window */}
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f9f9f7",
        }}
      >
        <div
          style={{
            flexGrow: 1,
            padding: "16px",
            overflowY: "auto",
            backgroundColor: "#f5f5f5",
          }}
        >
          {messages.length === 0 ? (
            <p style={{ textAlign: "center", color: "#9e9e9e" }}>{activeChat ? "No messages yet." : "Start a new chat or select a conversation."}</p>
          ) : (
            messages.map((msg, index) => (
              <div key={index} style={{ display: "flex", justifyContent: msg.is_bot ? "flex-start" : "flex-end", marginBottom: "8px" }}>
                <div style={{ padding: "10px", borderRadius: "20px", backgroundColor: msg.is_bot ? "#e0e0e0" : "#3f51b5", color: msg.is_bot ? "#000" : "#fff", maxWidth: "70%", wordBreak: "break-word", fontSize: "14px", lineHeight: "1.5" }}
                  dangerouslySetInnerHTML={{ __html: marked(msg.text) }} />
              </div>
            ))
          )}
  
          {isTyping && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginTop: "8px",
              }}
            >
              <p
                style={{
                  padding: "10px 15px",
                  borderRadius: "20px",
                  backgroundColor: "#e0e0e0",
                  color: "#000",
                  maxWidth: "50%",
                  fontSize: "14px",
                  fontStyle: "italic",
                }}
              >
                Typing{typingDots}
              </p>
            </div>
          )}
        </div>
  
        {/* Input Area */}
        <div
          style={{
            padding: "16px",
            backgroundColor: "#ffffff",
            borderTop: "1px solid #ddd",
            display: "flex",
            alignItems: "center",
            boxShadow: "0px -2px 5px rgba(0, 0, 0, 0.1)",
          }}
        >
          <input
            type="text"
            value={currentMessage}
            onChange={(e) => setCurrentMessage(e.target.value)}
            placeholder="Type your message..."
            style={{
              flex: 1,
              padding: "10px",
              marginRight: "8px",
              borderRadius: "20px",
              border: "1px solid #ddd",
              backgroundColor: "#f7f7f7",
            }}
          />
          <button
            onClick={handleSendMessage}
            disabled={!currentMessage.trim()}
            style={{
              padding: "10px 20px",
              color: "#fff",
              backgroundColor: "#0B194A",
              border: "none",
              borderRadius: "20px",
              cursor: "pointer",
            }}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}  